import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAppearances } from '../../../redux/homeSlice';
import Testimonial from '../../components/testimonial/Testimonial';
import PopularCat from './popularCat/PopularCat';
import Aboutuscomp from './Aboutuscomp/Aboutuscomp';
import Counter from './counter/Counter';
import Featured from '../../components/Featured/Featured';
import RecentlyViewed from './recentlyViewed/RecentlyViewed';
import Sparkle from './Sparkle/Sparkle';
import Hero from './Hero/Hero';
import Loader from '../../components/Loader/Loader';
import Instafeedbk from './instafeedbk/Instafeedbk';
import MapScreen from './map/MapScreen';


const Home = () => {

  const dispatch = useDispatch();
  const { appearanceData, isLoading } = useSelector((state) => state.appearances);

  //heroBanners
  const heroBanners = appearanceData?.herobanner?.banner

  //categories
  const categoriesData = appearanceData?.categories

  //aboutUsData
  const aboutUsData = appearanceData?.aboutus;

  //featurerdproducts
  const featurerdproducts = appearanceData?.featurerdproducts;

  //OfferBanner
  const offerbanner = appearanceData?.offerbanner;

  //testimonials
  const testimonials = appearanceData?.testimonials;

  //instagrams
  const instagrams = appearanceData?.instagram?.instagram;

  useEffect(() => {
    dispatch(getAppearances())
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isLoading) {
    return (
      <Loader />
    )
  };

  return (
    <>
      <div style={{ background: "#FFFBFB", position: 'relative' }}>
        <div>
          <div style={{ position: 'absolute', top: '9%' }}>
            <img src='/assets/Ellipse1.png' />
          </div>
          <div style={{ position: 'absolute', top: '3%', right: '0px', }}>
            <img src='/assets/Ellipse2.png' />
          </div>
          <div style={{ position: 'absolute', top: '16%' }}>
            <img src='/assets/Ellipse1.png' />
          </div>
          <div style={{ position: 'absolute', top: '22%', right: '0px', }}>
            <img src='/assets/Ellipse2.png' />
          </div>
          <div style={{ position: 'absolute', top: '29%' }}>
            <img src='/assets/Ellipse1.png' />
          </div>
          <div style={{ position: 'absolute', top: '35%', right: '0px', }}>
            <img src='/assets/Ellipse2.png' />
          </div>
          <div style={{ position: 'absolute', top: '42%' }}>
            <img src='/assets/Ellipse1.png' />
          </div>
          <div style={{ position: 'absolute', top: '49%', right: '0px', }}>
            <img src='/assets/Ellipse2.png' />
          </div>
          <div style={{ position: 'absolute', top: '56%' }}>
            <img src='/assets/Ellipse1.png' />
          </div>
          <div style={{ position: 'absolute', top: '64%', right: '0px', }}>
            <img src='/assets/Ellipse2.png' />
          </div>
          <div style={{ position: 'absolute', top: '71%' }}>
            <img src='/assets/Ellipse1.png' />
          </div>
          <div style={{ position: 'absolute', top: '80%', right: '0px', }}>
            <img src='/assets/Ellipse2.png' />
          </div>
        </div>
        <Hero heroBanners={heroBanners} />
        <PopularCat categoriesData={categoriesData || []} isLoading={isLoading} />
        <Aboutuscomp aboutUsData={aboutUsData} />
        <Featured featurerdproducts={featurerdproducts} />
        <Counter />
        <Sparkle offerbanner={offerbanner} />
        <Testimonial testimonials={testimonials} />
        <RecentlyViewed />
        <Instafeedbk instagrams={instagrams} />
        <MapScreen />
      </div>
    </>
  )
};

export default Home;